// eslint-disable-next-line import/named
import styled from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectTypography } from '../../utils/injectTypography';
const styledAccordionStateConfig = {
    shouldForwardProp: (prop) => !['open', 'defaultOpen'].includes(prop),
};
export const StyledAccordion = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: stretch;

  ${injectSpacing('margin')}
`;
export const StyledSectionHeader = styled.h2 `
  all: revert;

  margin: 0;

  background-color: ${(props) => props.theme.colors.ui.primaryInverse};

  &:not(:first-child) {
    margin-top: -1px;
  }

  &:focus-within {
    z-index: 1;
  }
`;
export const StyledSectionHeaderLabel = styled.span `
  display: grid;
  grid-column: section-label;

  color: ${(props) => props.theme.colors.ui.primary};

  transition: transform 200ms ${(props) => props.theme.easing};
  margin-inline-end: var(${(props) => props.theme.responsive.spacing.m});

  ${(props) => injectTypography(props, 'copy1')}

  @media (max-width: 439px) {
    hyphens: auto;
  }
`;
export const StyledSectionHeaderButton = styled.button `
  all: revert;

  display: block;
  width: 100%;
  margin: 0;
  padding: 0;

  text-align: start;

  background: transparent;
  border: solid ${(props) => props.theme.colors.utility.neutral['20']};
  border-width: 1px 0;

  cursor: pointer;

  appearance: none;

  &:hover ${StyledSectionHeaderLabel}, &:focus ${StyledSectionHeaderLabel} {
    transform: translateX(4px);

    [dir='rtl'] & {
      transform: translateX(-4px);
    }
  }
`;
export const StyledSectionHeaderButtonContent = styled.div `
  display: grid;
  grid-template-columns:
    [section-icon] minmax(0, max-content)
    [section-label] auto
    [arrow-icon] max-content;
  padding: var(${(props) => props.theme.responsive.spacing.m})
    var(${(props) => props.theme.responsive.spacing.l});
`;
export const StyledIcon = styled.svg.withConfig(styledAccordionStateConfig) `
  grid-column: arrow-icon;

  width: 24px;
  height: 24px;

  color: ${(props) => props.theme.colors.ui.primary};

  transform: rotateZ(${(props) => (props.open ? -180 : 0)}deg);

  transition: transform 200ms ${(props) => props.theme.easing};

  pointer-events: none;

  [dir='rtl'] & {
    transform: rotateZ(${(props) => (props.open ? 180 : 0)}deg);
  }
`;
const transitionDuration = 400;
export const StyledSectionPanel = styled.div.withConfig(styledAccordionStateConfig) `
  --panel-height: ${(props) => (props.defaultOpen ? 'auto' : '0px')};

  box-sizing: border-box;
  height: var(--panel-height);
  overflow: hidden;

  background-color: ${(props) => props.theme.colors.utility.neutral['5']};
  visibility: ${(props) => (props.open ? 'visible' : 'hidden')};

  transition: ${transitionDuration}ms ${(props) => props.theme.easing};
  transition-property: height, visibility;
`;
export const StyledSectionPanelContent = styled.div.withConfig(styledAccordionStateConfig) `
  --inset: var(${(props) => props.theme.responsive.spacing.l});

  box-sizing: border-box;
  padding: var(--inset);

  transform: ${(props) => !props.open && 'translateY(calc(var(--inset) / 2))'};
  opacity: ${(props) => (props.open ? 1 : 0)};

  transition-delay: ${(props) => (props.open ? transitionDuration * 0.2 : 0)}ms;
  transition-timing-function: ${(props) => props.theme.easing};
  transition-duration: ${transitionDuration * 0.8}ms;
  transition-property: transform, opacity;
`;
export const StyledIconContainer = styled.div `
  grid-column: section-icon;
  margin-inline-end: var(${(props) => props.theme.responsive.spacing.m});

  width: 24px;
  height: 24px;
`;
//# sourceMappingURL=Accordion.styles.js.map